import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <SpringArm3D>: a Node3D group that draws Godot's length line for every node, faint while
 * unselected (ADR-0056): one segment from the origin to (0, 0, spring_length), unguarded, so 0 and a
 * negative length draw as in spring_arm_3d_gizmo_plugin.cpp:35-54.
 */
import { useMemo } from 'react';
import { Node3D } from '../../../base/node3d/Component';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { CollisionDebugLines } from '../../shared/CollisionDebugLines';
import { DEFAULT_SPRING_LENGTH } from './types';
function LengthGizmo({ length }) {
    const positions = useMemo(() => new Float32Array([0, 0, 0, 0, 0, length]), [length]);
    return _jsx(CollisionDebugLines, { positions: positions });
}
export function SpringArm3D({ node, children }) {
    const props = node.properties;
    return (_jsxs(Node3D, { node: node, children: [_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(LengthGizmo, { length: props.spring_length ?? DEFAULT_SPRING_LENGTH }) }), children] }));
}
//# sourceMappingURL=Component.js.map